module.exports = __webpack_public_path__ + "img/egg-fried.87112bc1.svg";